import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../components/Form/Button";
import { Waybill } from "../../../../../../models/waybill";
import { Description, DescriptionWrapper, Warning } from "./styled";

interface DeleteWaybillModalProps {
  onDelete: (waybill?: Waybill) => void;
  isDeleting?: boolean;
}

export interface DeleteWaybillHandle {
  onOpenModal: (data: Waybill) => void;
  onCloseModal: () => void;
}

const DeleteWaybillModal: ForwardRefRenderFunction<DeleteWaybillHandle, DeleteWaybillModalProps> = (
  props,
  ref
) => {
  const { onDelete, isDeleting } = props;
  const { t: translate } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);
  const [waybill, setWaybill] = useState<Waybill>();

  const onOpenModal = (data: Waybill) => {
    setWaybill(data);
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    onOpenModal,
    onCloseModal: () => setOpen(false),
  }));

  return (
    <ConfirmationModal
      open={open}
      closeModal={() => setOpen(false)}
      type="error"
      title={translate("cancelShipment")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={isDeleting}
      cancelDisabled={isDeleting}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("back")}
      textSubmit={translate("yesDeleteShipment")}
      submit={() => onDelete(waybill)}
      width="520px !important"
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className="w-100">
          <DescriptionWrapper data-cy="confirmationModalCancelBody">
            <Description>
              {translate("areYouSureYouWantToDeleteThisShipment")}{" "}
              {waybill?.containerNumbers ? waybill.containerNumbers : ""}?
            </Description>

            <Warning className="error">
              {translate("thisActionIsPermanentAndCannotBeUndone")}
            </Warning>
          </DescriptionWrapper>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteWaybillModal);
